import {
	INVESTOR_TEST_ELEMENT_ID,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { SHAREHOLDER_INVESTMENT_STATUS } from '@dealstack/shared/lib/common/business/shareholder';
import { Badge, Text } from '@mantine/core';
import styled from 'styled-components';

const STYLE_VARIANTS = {
	[SHAREHOLDER_INVESTMENT_STATUS.PENDING_APPROVAL]: {
		bgColor: defaultTheme.v3.colors.orange[9],
		textColor: defaultTheme.v3.colors.orange[4],
	},
	[SHAREHOLDER_INVESTMENT_STATUS.COMPLETED]: {
		bgColor: defaultTheme.v3.colors.green[9],
		textColor: defaultTheme.v3.colors.green[4],
	},
	[SHAREHOLDER_INVESTMENT_STATUS.NEW_OFFER]: {
		bgColor: defaultTheme.v2.color.secondary[1200],
		textColor: defaultTheme.v2.color.secondary[600],
	},
	[SHAREHOLDER_INVESTMENT_STATUS.NEEDS_ATTENTION]: {
		bgColor: defaultTheme.v3.colors.yellow[9],
		textColor: defaultTheme.v3.colors.yellow[4],
	},
	[SHAREHOLDER_INVESTMENT_STATUS.PENDING]: {
		bgColor: defaultTheme.v3.colors.orange[9],
		textColor: defaultTheme.v3.colors.orange[4],
	},
};

interface ICardHeader {
	className?: string;
	status?: SHAREHOLDER_INVESTMENT_STATUS;
	type?: string;
	text?: string;
}

export const CardHeader = styled(({ className, type, text }: ICardHeader) => {
	return (
		<div className={className}>
			<UIElementIdentifier identifier={INVESTOR_TEST_ELEMENT_ID.INVESTOR_CARD_HEADER_STATUS}>
				<Text size="B6Bold">{text}</Text>
			</UIElementIdentifier>
			<Badge
				variant="outline"
				style={{
					padding: '0.25rem 0.5rem',
					color: defaultTheme.v3.colors.gray[4],
					border: `1px solid ${defaultTheme.v3.colors.gray[4]}`,
					borderRadius: '1rem',
					fontWeight: 400,
				}}
			>
				{type}
			</Badge>
		</div>
	);
})`
	background-color: ${({ status }) => status && STYLE_VARIANTS[status].bgColor};
	color: ${({ status }) => status && STYLE_VARIANTS[status].textColor};
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.5rem;
	border-radius: 0.5rem 0.5rem 0 0;
`;
